// src/slices/ticketType/thunk.ts
// Async thunks cho Quản lý Loại Vé

import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  getTicketTypes,
  getActiveTicketTypes,
  createTicketType as createTicketTypeAPI,
  updateTicketType as updateTicketTypeAPI,
  lockTicketType as lockTicketTypeAPI,
  unlockTicketType as unlockTicketTypeAPI,
} from 'helpers/fakebackend_helper';
import { CreateTicketTypeDto, UpdateTicketTypeDto } from 'pages/TicketTypeManagement/types';

interface GetTicketTypesParams {
  pageIndex?: number;
  pageSize?: number;
  search?: string;
  isLocked?: boolean;
}

const cleanParams = (params: any): any => {
  const cleaned: any = {};
  Object.keys(params).forEach((key) => {
    const value = params[key];
    if (value !== null && value !== undefined && value !== '') {
      cleaned[key] = value;
    }
  });
  return cleaned;
};

export const fetchTicketTypes = createAsyncThunk(
  'TicketType/fetchTicketTypes',
  async (params: GetTicketTypesParams = {}, { rejectWithValue }) => {
    try {
      const response = await getTicketTypes(cleanParams(params));
      return response.data || response;
    } catch (error: any) {
      return rejectWithValue(error?.message || 'Có lỗi xảy ra khi tải danh sách loại vé');
    }
  }
);

export const fetchActiveTicketTypes = createAsyncThunk(
  'TicketType/fetchActiveTicketTypes',
  async (_: void, { rejectWithValue }) => {
    try {
      const response = await getActiveTicketTypes();
      return response.data || response;
    } catch (error: any) {
      return rejectWithValue(error?.message || 'Có lỗi xảy ra khi tải danh sách loại vé đang mở');
    }
  }
);

export const createTicketType = createAsyncThunk(
  'TicketType/create',
  async (data: CreateTicketTypeDto, { rejectWithValue }) => {
    try {
      const response = await createTicketTypeAPI(data);
      return response.data || response;
    } catch (error: any) {
      return rejectWithValue(error?.message || 'Có lỗi xảy ra khi tạo loại vé');
    }
  }
);

export const updateTicketType = createAsyncThunk(
  'TicketType/update',
  async (data: UpdateTicketTypeDto, { rejectWithValue }) => {
    try {
      const response = await updateTicketTypeAPI(data.id, data);
      return response.data || response;
    } catch (error: any) {
      return rejectWithValue(error?.message || 'Có lỗi xảy ra khi cập nhật loại vé');
    }
  }
);

export const lockTicketType = createAsyncThunk(
  'TicketType/lock',
  async (id: number, { rejectWithValue }) => {
    try {
      await lockTicketTypeAPI(id);
      return id;
    } catch (error: any) {
      return rejectWithValue(error?.message || 'Có lỗi xảy ra khi khóa loại vé');
    }
  }
);

export const unlockTicketType = createAsyncThunk(
  'TicketType/unlock',
  async (id: number, { rejectWithValue }) => {
    try {
      await unlockTicketTypeAPI(id);
      return id;
    } catch (error: any) {
      return rejectWithValue(error?.message || 'Có lỗi xảy ra khi mở khóa loại vé');
    }
  }
);
